var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/navigation/LinkBase.tsx";
import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Base component for Link components. Applies common attributes and styles.
 */
const LinkBaseNext = function LinkBase({
  children,
  classes,
  elementRef,
  unstyled = false,
  ...htmlAttributes
}) {
  return _jsxDEV("a", {
    "data-base-component": "LinkBase"
    /* data-component will be overwritten unless this component is used directly */,
    "data-component": "LinkBase",
    ...htmlAttributes,
    className: classnames({
      'focus-visible-ring': !unstyled
    }, classes),
    rel: "noopener noreferrer",
    ref: downcastRef(elementRef),
    children: children
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 21,
    columnNumber: 5
  }, this);
};
export default LinkBaseNext;
//# sourceMappingURL=LinkBase.js.map